<template>
  <el-form ref="emailForm" :model="formData" :rules="rules"  label-position="left" label-width="auto" style="width: 600px">
    <el-form-item :label="$t('lang.输入邮件验证码')" prop="captcha">
      <el-row :gutter="24">
        <el-col :span="20" style="padding: 0">
          <el-input v-model="formData.captcha"></el-input>
        </el-col>
        <el-col :span="2">
          <el-button type="warning" @click="handleResetSend" :disabled="isSend">
            {{$t('lang.重新发送')}} {{ sendNum ? sendNum : '' }}
          </el-button>
        </el-col>
      </el-row>
    </el-form-item>

    <el-form-item size="medium" style="display: flex;justify-content: center">
      <el-button size="medium" type="primary" style="width: 120px" @click="handleNext">{{$t('lang.下一步')}}</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  name: "VerifyEmailCodeForm",
  props: {
    email: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      rules: {
        captcha: [
          { required: true, message: '请输入邮箱验证码', trigger: 'blur' },
        ]
      },
      formData: {
        captcha: ''
      },
      isSend: true,
      sendNum: null,
    }
  },
  created() {
    this.handleCountDown();
  },
  methods: {
    // 发送验证码
    handleResetSend() {
      const vm  = this;
      vm.$http.post(vm.$api.email.captcha, vm.$qs.stringify({email: vm.email})).then(res => {
        if(res.data.status != 200) {
          vm.$message.error(res.data.desc);
          return;
        }
        vm.$message.success(res.data.desc);
        vm.isSend = true;
        vm.handleCountDown();
      }).catch(err => {
        console.log('获取失败', err);
      })
    },
    handleCountDown() {
      let second = 60;
      const vm = this;
      if(vm.isSend) {
        let timer = setInterval(() => {
          if(second == 0) {
            clearTimeout(timer);
            vm.isSend = false;
            vm.sendNum = null;
            return;
          }

          if(second < 10) {
            vm.sendNum = `（0${second}）`;
          } else {
            vm.sendNum = `（${second}）`;
          }
          second --;
        }, 1000)
      }
    },

    handleNext() {
      const vm = this;
      this.$refs['emailForm'].validate((valid) => {
        if (valid) {
          vm.$emit('next', vm.formData);
        }
      });
    }
  }
}
</script>

<style scoped>

</style>
